module.exports = __webpack_public_path__ + "img/logo-icon.61bf478f.png";